import { useRouter } from 'next/router'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'
import { ProductLine } from '@mc/track-event'
import Image from 'components/LegacyImage'
import Link from 'components/Link'
import {
  EnterpriseMobileMenu,
  GlobalTopNavigation,
} from 'components/Navigation/global-navigation'
import { AdminLink } from '../shared/AdminLink'
import { LoginMenu } from '../shared/LoginMenu'
import { BrowseSkillsLibraryCta } from './BrowseSkillsLibraryCta'
import { HowItWorksCta } from './HowItWorksCta'
import { NavActions } from './NavActions'
import { trackMAWLogoClick } from './utils'

const EnterpriseNavigation = () => {
  const { pathname, query } = useRouter()
  const showBrowseLibraryCTA = (
    [
      paths.enterpriseHomepage,
      paths.enterpriseCart,
      paths.enterpriseHowItWorks,
    ] as string[]
  ).includes(pathname)

  const logoUrl =
    pathname === paths.enterpriseHomepage
      ? paths.root
      : paths.enterpriseHomepage

  return (
    <>
      <GlobalTopNavigation
        className='mc-py-1'
        contained
        showOnCallLink
        showAtWorkLink
        product={ProductLine.AT_WORK}
      />
      <Nav
        background='solid'
        className='mc-page__header'
        data-testid='enterprise-navbar'
      >
        <div className='col-6 col-sm-auto d-flex align-items-center'>
          <Link
            className='d-flex align-items-center mc-mr-4'
            href={logoUrl}
            onClick={trackMAWLogoClick({
              logoUrl,
              pathname,
              query,
            })}
            isBasic
          >
            <Image
              src='https://static.masterclass.com/mc-enterprise-logo.png'
              alt='MasterClass Logo'
              width={173}
              height={24}
            />
          </Link>
          {showBrowseLibraryCTA && (
            <div className='d-flex'>
              <div className='d-none d-md-block'>
                <HowItWorksCta
                  textCTAKey='nav.cta.howItWorks'
                  className='mc-py-0'
                />
              </div>
              <div className='d-none d-md-block'>
                <BrowseSkillsLibraryCta
                  textCTAKey='nav.cta.browseSkillsLibrary'
                  className='mc-py-0'
                />
              </div>
            </div>
          )}
        </div>
        <Nav.Right>
          <div className='d-none d-md-block'>
            <AdminLink />
          </div>
          <LoginMenu product={ProductLine.AT_WORK}>
            <EnterpriseMobileMenu />
          </LoginMenu>
          <div className='d-none d-sm-block'>
            <NavActions />
          </div>
        </Nav.Right>
      </Nav>
    </>
  )
}

export default EnterpriseNavigation
